import React from 'react';
import { useCookiePolicy } from "../../Components/DataRetention/CookiePolicy";
import { getBrandName } from "../../Components/getBrandName";
const CookiePolicy = () => {
  const { sections, generateContent } = useCookiePolicy();
  const { brandName} = getBrandName();

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-heading text-center">
        <h2>Cookie Use & Preferences Policy</h2>
        <p className="text-muted" style={{fontSize:"0.8rem"}}>Effective Date: <strong>July 3, 2025</strong></p>
        <p className="text-muted" style={{fontSize:"0.8rem"}}>Version: 1.0</p>
      </div>

      <div className="privacy-container">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
        <p>
          At {brandName}, transparency and trust are key pillars of our data practices. This Cookie Use & Preferences Policy explains how we use cookies and similar technologies on our website and web-based services, and what choices you have regarding your cookie preferences.
          </p>
              {sections.map((section) => (
                <div key={section.id} className="mb-5">
                  <h5 className="fw-bold">{section.title}</h5>
                  <div className="text-muted">
                    {generateContent(section.id)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
